import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CmsValue, ListStoresParams } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  BUSINESS_NAME_LABEL,
  CMS_LABEL,
  FORM_COMPANY_ID_FIELD_LABEL,
  NAME_LABEL,
  SALES_NETWORK_ID_LABEL,
  STATUS_LABEL,
  STORE_ID_LABEL,
  VAT_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-stores-filters',
  templateUrl: './stores-filters.component.html',
  styleUrls: ['./stores-filters.component.scss'],
})
export class StoresFiltersComponent {
  @Input() filters?: ListStoresParams;
  @Output() filter_clear: EventEmitter<ListStoresParams> = new EventEmitter<ListStoresParams>();

  constructor(private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        if (!this.filters) return false;
        return this.filters[k as keyof typeof this.filters] != null;
      });
    }
    return [];
  }

  getLabelByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    switch (key) {
      case available_keys[0]:
        return STORE_ID_LABEL;
      case available_keys[1]:
        return NAME_LABEL;
      case available_keys[2]:
        return STATUS_LABEL;
      case available_keys[3]:
        return CMS_LABEL;
      case available_keys[4]:
        return VAT_LABEL;
      case available_keys[5]:
        return BUSINESS_NAME_LABEL;
      case available_keys[6]:
        return SALES_NETWORK_ID_LABEL;
      case available_keys[7]:
        return FORM_COMPANY_ID_FIELD_LABEL;
      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    switch (key) {
      case available_keys[0]:
        return this.filters?.store_id || '-';
      case available_keys[1]:
        return this.filters?.name || '-';
      case available_keys[2]:
        return this.getStoreStatusLabel(this.filters?.status);
      case available_keys[3]:
        return this.getCompanyCMSLabel(this.filters?.cms);
      case available_keys[4]:
        return this.filters?.vat || '-';
      case available_keys[5]:
        return this.filters?.business_name || '-';
      case available_keys[6]:
        return this.filters?.sales_network_id || '-';
      case available_keys[7]:
        return this.filters?.company_id || '-';
      default:
        return '';
    }
  }

  getStoreStatusLabel(status?: 'enabled' | 'disabled'): string {
    const store = { order_requirements: { is_enabled: status == 'enabled' } };
    return this.utils_service.getStoreStatusLabel(store);
  }

  getCompanyCMSLabel(cms?: CmsValue): string {
    if (!cms) return '';
    return this.utils_service.getCMSLabel(cms);
  }
}
